import React, { useState } from 'react';
import { Tabs } from 'antd';
import CSACartList from '../../components/CSACartList';
import CSAList from '../../components/CSAList';
import CSASkuSearch from '../../components/CSASkuSearch';
import './style.scss';

const AllCSACarts = () => {
    const [activeTab, setActiveTab] = useState('cart-list');

    const tabItems = [
        {
            key: 'cart-list',
            label: 'CSA Cart List',
            children: <CSACartList />,
        },
        {
            key: 'csa-list',
            label: 'Available Fundus',
            children: <CSAList />,
        },
        {
            key: 'sku-search',
            label: 'Search SKU',
            children: <CSASkuSearch />,
        },
    ];

    return (
        <div className="all-csa-carts-main_wrapper">
            <div className="all-csa-carts-tabs">
                <Tabs
                    activeKey={activeTab}
                    onChange={setActiveTab}
                    items={tabItems}
                />
            </div>
        </div>
    );
};

export default AllCSACarts;
